import React, { ReactNode, useEffect, useState } from "react";
import { BellOutlined, LeftOutlined, UserOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "../../../Redux/reduxCustomHook";
import { RootState } from "../../../Redux/store";
import "./topbar.css";
import MiniAudioPlayer from "../../sharedcomponents/AudioPlayerSmallComp";
import { IAuthType } from "../../../apiservice/authService.type";
import { Modal } from "antd";
import { appZIndex } from "../../../utils/appconst";
import { Device } from "@capacitor/device";

type ITopBar = {
  title?: string;
  displayType?: "search" | "title" | "none" | "logo";
  showBackButton?: boolean;
  showNotification?: boolean;
  showProfileBtn?: boolean;
  backButtonHref?: string;
};

export const TopBar: React.FC<ITopBar> = ({
  title,
  displayType = "logo",
  showBackButton = false,
  showNotification = false,
  backButtonHref = "/",
  showProfileBtn = false,
}) => {
  const authData: IAuthType = useAppSelector(
    (state: RootState) => state?.AuthData
  );

  const navigate = useNavigate();

  const notificationItemsCount = 0;
  const [usePaddedLogic, setUsePaddedLogic] = useState(false);

  // Navigate Backwards
  const navigateBackward = (url: string) => {
    navigate(-1);
  };

  // Navigate To Page
  const navigateToPage = (page: string) => {
    navigate(page);
  };

  // Show Sign In Alert
  const showSignInAlert = (title: string, content: ReactNode, url: string) => {
    Modal.confirm({
      title,
      content,
      async onOk() {
        navigate(url);
      },
      onCancel() {
        console.log("Cancelled");
      },
      zIndex: appZIndex.modal,
    });
  };

  useEffect(() => { getDeviceOSVersion(); }, [])


  const getDeviceOSVersion = async () => {
    try {
      const info = await Device.getInfo();
      console.log('Device Information:', info);

      const platform = info.operatingSystem; // e.g., 'ios' or 'android'
      const osApiLevel = info.androidSDKVersion;

      if (platform === "ios") {
        setUsePaddedLogic(true);
      }

    } catch (error) {
      console.error('Error getting device info:', error);
      return null;
    }
  };

  return (
    <>
      {/* Top Bar Card */}
      <div className={` ${usePaddedLogic ? " fixedMenuios  safeAreaTopios " : " fixedMenu safeAreaTop "} border-b dark:border-b-stone-700 bg-white dark:bg-stone-800 z-[10000000000000]`}>
        <div>
          <div className="grid">
            <div className="p-4 flex justify-center items-center">
              {showBackButton && (
                <div className="flex items-center w-9">
                  <p
                    className="font-sans text-lg cursor-pointer text-gray-700 dark:text-blue-400 hover:text-blue-600 dark:hover:text-blue-300"
                    onClick={() => navigateBackward(backButtonHref)}
                  >
                    <LeftOutlined /> &nbsp;
                  </p>
                </div>
              )}

              <div className="flex-grow items-center">
                <div>
                  {displayType === "title" && (
                    <p className="fontKanitRegular font-medium text-lg pt-1 text-gray-900 dark:text-stone-100">
                      {title || "KeyWay App"}
                    </p>
                  )}

                  {displayType === "search" && (
                    <input
                      readOnly
                      className="w-full h-10 bg-stone-300 dark:bg-stone-700 rounded-2xl p-2 font-sans text-sm text-gray-900 dark:text-stone-100 placeholder-gray-600 dark:placeholder-stone-400"
                      placeholder="Search Service, Stylist or Salon"
                      onClick={() =>
                        navigateToPage("/explore/explore-start-search")
                      }
                    />
                  )}

                  {displayType === "logo" && (
                    <p className="fontKanitRegular font-bold text-xl tracking-tight pt-1 text-blue-800 dark:text-stone-100">
                      {/* <img
                        className="w-48 rounded-xl"
                        alt="_img"
                        src={`${process.env.PUBLIC_URL + "/images/logoblue.svg"}`}
                      /> */}
                      KeyWay App
                    </p>
                  )}
                </div>
              </div>

              {showNotification && (
                <div className="flex items-center justify-end space-x-2 w-12">
                  <div
                    className="relative cursor-pointer"
                    onClick={() => {
                      if (authData?.data?.credentials?.email) {
                        navigateToPage("/users/notification");
                        return;
                      }
                      showSignInAlert(
                        "Login To Your Account",
                        "Please Login to your account to have access to this page.",
                        "/auth"
                      );
                    }}
                  >
                    <span className="w-10 h-10 flex items-center justify-center rounded-full bg-gray-100 dark:bg-stone-700">
                      <BellOutlined className="text-lg text-blue-800 dark:text-blue-400" />
                    </span>
                    {notificationItemsCount > 0 && (
                      <span className="absolute -top-1 -right-1 bg-red-500 text-white text-[10px] font-semibold rounded-full min-w-[18px] h-[18px] px-1 flex items-center justify-center ring-2 ring-white dark:ring-stone-800">
                        {notificationItemsCount > 9
                          ? "9*"
                          : notificationItemsCount}
                      </span>
                    )}
                  </div>
                </div>
              )}

              {showProfileBtn && (
                <div className="flex items-center justify-end space-x-2 w-12">
                  <div
                    className="relative cursor-pointer"
                    onClick={() => {
                      if (authData?.data?.credentials?.email) {
                        navigateToPage("/users/profile");
                        return;
                      }
                      showSignInAlert(
                        "Login To Your Account",
                        "Please Login to your account to have access to this page.",
                        "/auth"
                      );
                    }}
                  >
                    <span className="w-10 h-10 flex items-center justify-center rounded-full bg-gray-100 dark:bg-stone-700">
                      <UserOutlined className="text-lg text-blue-800 dark:text-blue-400" />
                    </span>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className={`grid  ${usePaddedLogic ? " menuSpaceios " : "menuSpace"}`}>
        <br />
      </div>

      <MiniAudioPlayer></MiniAudioPlayer>
    </>
  );
};

export default TopBar;
